/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do salt and oligo concentration matter?`)
};

const es_tm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué importan la sal y la concentración de oligo?`)
};

const de_tm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum sind Salz- und Oligo-Konzentration wichtig?`)
};

const nl_tm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom zijn zout- en oligoconcentratie belangrijk?`)
};

const fr_tm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi le sel et la concentration d'oligo comptent-ils ?`)
};

const it_tm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché la concentrazione salina e dell'oligo sono importanti?`)
};

const pt_br2_tm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que a concentração de sal e do oligo importam?`)
};

const pt_tm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque importam a concentração salina e de oligo?`)
};

const ja_tm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`塩濃度とオリゴ濃度が重要なのはなぜですか？`)
};

const zh_tm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么盐浓度和寡核苷酸浓度很重要？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_faq_q2", locale)
	if (locale === "en") return en_tm_faq_q2(inputs)
	if (locale === "es") return es_tm_faq_q2(inputs)
	if (locale === "de") return de_tm_faq_q2(inputs)
	if (locale === "nl") return nl_tm_faq_q2(inputs)
	if (locale === "fr") return fr_tm_faq_q2(inputs)
	if (locale === "it") return it_tm_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_tm_faq_q2(inputs)
	if (locale === "pt") return pt_tm_faq_q2(inputs)
	if (locale === "ja") return ja_tm_faq_q2(inputs)
	return zh_tm_faq_q2(inputs)
};